// extracted by mini-css-extract-plugin
export default {"page_404":"ErrorNoResult_page_404__FsCCY","four_zero_four_bg":"ErrorNoResult_four_zero_four_bg__ShYuD","notResult__h3":"ErrorNoResult_notResult__h3__AdMo1"};